import { RxapDataSource } from 'eurogard-data-source';
import { Injectable, inject } from '@angular/core';
import { PanelAccordionDataSource } from 'eurogard-data-source/accordion';
import {
  UserControllerGetFirebaseRegistrationTokenRemoteMethod
} from 'open-api-legacy/remote-methods/user-controller-get-firebase-registration-token.remote-method';
import {
  UserControllerGetFirebaseRegistrationTokenResponse
} from 'open-api-legacy/responses/user-controller-get-firebase-registration-token.response';

@Injectable()
@RxapDataSource('firebase-tokens-panel')
export class FirebaseTokensDataSource extends PanelAccordionDataSource<UserControllerGetFirebaseRegistrationTokenResponse> {
  protected override readonly method = inject(UserControllerGetFirebaseRegistrationTokenRemoteMethod);
}
